import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [station, setStation] = useState("");
  const [userStationId, setUserStationId] = useState("");
  const [roles, setRoles] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decodedToken = jwtDecode(token);
      setUser(decodedToken.data);
      setUserStationId(decodedToken.data?.stations[0]);
      if (decodedToken.data?.roles && decodedToken.data.roles.length > 0) {
        setRoles(decodedToken.data.roles[0]);
      }
    } catch (error) {
      console.error("Auth initialization error:", error);
      navigate("/signin");
    }
  }, [token]);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        token,
        setToken,
        userStationId,
        setUserStationId,
        station,
        setStation,
        roles,
        setRoles,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProvider };